/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { BookingAssetInfoFromJSON, BookingAssetInfoFromJSONTyped, BookingAssetInfoToJSON, BookingAssetInfoToJSONTyped, } from './BookingAssetInfo';
/**
 * Check if a given object implements the BookingPublicV2 interface.
 */
export function instanceOfBookingPublicV2(value) {
    if ((!('adReportingId' in value) && !('AdReportingId' in value)) || (value['adReportingId'] === undefined && value['AdReportingId'] === undefined))
        return false;
    return true;
}
export function BookingPublicV2FromJSON(json) {
    return BookingPublicV2FromJSONTyped(json, false);
}
export function BookingPublicV2FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'name': json['Name'] == null ? undefined : json['Name'],
        'refSlot': json['RefSlot'] == null ? undefined : json['RefSlot'],
        'adReportingId': json['AdReportingId'],
        'slotAssets': json['SlotAssets'] == null ? undefined : (json['SlotAssets'].map(BookingAssetInfoFromJSON)),
    };
}
export function BookingPublicV2ToJSON(json) {
    return BookingPublicV2ToJSONTyped(json, false);
}
export function BookingPublicV2ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Name': value['name'],
        'RefSlot': value['refSlot'],
        'AdReportingId': value['adReportingId'],
        'SlotAssets': value['slotAssets'] == null ? undefined : (value['slotAssets'].map(BookingAssetInfoToJSON)),
    };
}
